import { Badge } from 'gql/autogen/Badge';
import { Box, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { roundBookingCount } from 'core/utils/roundBookingCount';
import { getBookingCountForBadge } from 'core/utils/badgeUtil';

interface BookingCounterProps {
    showSeparator: boolean;
    badges: Badge[];
}

const BookingCounter: React.FC<BookingCounterProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const bookingCount = getBookingCountForBadge(props.badges);
    if (!bookingCount) return null;

    const formattedBookingCount = roundBookingCount(bookingCount || 0);
    const formattedText = StringFormatter.format(cms[337015], formattedBookingCount);

    return (
        <Box data-testid="booking-counter" display="inline-flex" mt="2">
            {props.showSeparator && (
                <Typography display="inline-flex" variant="caption-default" mx="4" textColor="base.subtle">
                    {StringFormatter.format('•')}
                </Typography>
            )}
            <Typography display="inline-flex" key="totalCount" variant="caption-default" textColor="base.subtle">
                {formattedText}
            </Typography>
        </Box>
    );
};

BookingCounter.displayName = 'BookingCounter';
export default BookingCounter;
